import { render, staticRenderFns } from "./juicyscore.vue?vue&type=template&id=1333802a&scoped=true"
import script from "./juicyscore.vue?vue&type=script&lang=js"
export * from "./juicyscore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1333802a",
  null
  
)

export default component.exports